import React from "react";
import EMDRimage from "../../../assets/EMDR.png";
import {
  ArrowsMove,
  ShieldCheck,
  ArrowRepeat,
  HeartPulse,
  Lightbulb,
  Check2
} from "react-bootstrap-icons";

function TherapyIcon({ name }) {
  if (name === "bilstim") return <ArrowsMove className="therapy-icon" />;
  if (name === "safe") return <ShieldCheck className="therapy-icon" />;
  if (name === "reprocess") return <ArrowRepeat className="therapy-icon" />;
  if (name === "relief") return <HeartPulse className="therapy-icon" />;
  if (name === "idea") return <Lightbulb className="therapy-icon" />;
  return null;
}

function CheckIcon() {
  return <Check2 className="therapy-check" />;
}

export default function EMDRModal({ setShow }) {
  return (
    <>
      <div
        className="therapy-modal-backdrop"
        onClick={() => setShow(false)}
      />

      <div
        className="modal fade show d-block therapy-modal-wrap"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg therapy-modal-dialog">
          <div className="modal-content therapy-modal-content">
            <div className="therapy-modal-hero">
              <div className="therapy-modal-hero-inner text-center">
                <img
                  src={EMDRimage}
                  className="img-fluid mx-auto d-block mb-3"
                  alt="EMDR"
                />

                <h5 className="therapy-modal-title">
                  What is EMDR
                </h5>

                <div className="therapy-modal-subtitle">
                  Trauma focused therapy explained
                </div>
              </div>

              <button
                type="button"
                className="btn-close therapy-modal-close"
                onClick={() => setShow(false)}
                aria-label="Close"
              />
            </div>

            <div className="modal-body therapy-modal-body">
              <div className="therapy-modal-card">
                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="bilstim" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Eye Movement Desensitisation and Reprocessing
                    </div>
                    <div className="therapy-modal-item-text">
                      EMDR is a structured therapy that helps the brain process
                      distressing memories and reduce the emotional intensity
                      connected to them. It uses bilateral stimulation such as
                      guided eye movements, tapping, or tones.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="safe" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Preparation and safety first
                    </div>
                    <div className="therapy-modal-item-text">
                      Before memory work begins, sessions often focus on
                      stabilising skills and support so the process feels
                      manageable and paced to you.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="reprocess" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Reprocessing memories
                    </div>
                    <div className="therapy-modal-item-text">
                      The aim is to help the mind integrate memories so they
                      feel more in the past than in the present, with fewer
                      triggers and less emotional charge.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-callout">
                  <div className="therapy-modal-callout-icon">
                    <TherapyIcon name="idea" />
                  </div>
                  <div className="therapy-modal-callout-text">
                    <span className="therapy-modal-callout-strong">
                      EMDR does not erase memories,
                    </span>{" "}
                    it helps reduce how distressing they feel and how much they
                    impact daily life.
                  </div>
                </div>

                <div className="therapy-modal-split">
                  <div className="therapy-modal-split-left">
                    <div className="therapy-modal-item-title mb-2">
                      EMDR can help clients to
                    </div>

                    <div className="therapy-modal-checklist">
                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Reduce the intensity of distressing memories and
                          triggers
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Shift negative beliefs linked to past events
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Feel safer in the present through grounding and
                          stabilising skills
                        </div>
                      </div>

                      <div className="therapy-modal-check">
                        <CheckIcon />
                        <div>
                          Improve sleep, mood, and day to day functioning over
                          time
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="therapy-modal-split-right">
                    <div className="therapy-modal-note">
                      EMDR is commonly used for PTSD and other trauma related
                      difficulties. The pace is guided by you, and therapists
                      often blend EMDR with stabilisation and coping strategies
                      to support the work.
                    </div>
                  </div>
                </div>

                <div className="therapy-modal-item">
                  <div className="therapy-modal-item-icon">
                    <TherapyIcon name="relief" />
                  </div>
                  <div className="therapy-modal-item-content">
                    <div className="therapy-modal-item-title">
                      Reducing distress over time
                    </div>
                    <div className="therapy-modal-item-text">
                      Many people find memories become less intrusive and less
                      emotionally overwhelming, making space for recovery and
                      rebuilding confidence.
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="modal-footer therapy-modal-footer">
              <button
                className="btn btn-brand-white fw-semibold therapy-modal-footer-btn"
                onClick={() => setShow(false)}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
